import { component } from 'flightjs';
import { toLocalizedRiotUrl } from 'tradera/utils/language';

function Login() {
    this._showLogin = function (evt, evtData) {
        const destination =
            evtData && evtData.destination
                ? evtData.destination
                : encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search);
        const url = toLocalizedRiotUrl('/login?ReturnUrl=' + destination);
        window.location.href = url;
    };

    this.after('initialize', function () {
        this.on(document, 'ui:login:show', this._showLogin);
    });
}

export default component(Login);
